import React, { FC, useState } from 'react';
import { Box, Button, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FreeTextFilterComponent from 'components/users/shared/free-text-filter/free-text-filter.component';
import FilterOnStatusDropdown from 'components/users/shared/filter-on-status-dropdown/filter-on-status-dropdown.component';
import { OrganizationListFilter } from 'models/common';

type LabPageActionsProps = {
    onFilterChange: ({ freeText, active }: OrganizationListFilter) => void;
    onAddLabDialogOpen: () => void;
};
const LabPageActions: FC<LabPageActionsProps> = ({ onFilterChange, onAddLabDialogOpen }: LabPageActionsProps) => {
    const { t: translate } = useTranslation(['organization']);
    const [filter, setFilter] = useState<OrganizationListFilter>({
        freeText: '',
        active: true,
    });

    const handleFilterChange = (freeTextInput: string) => {
        setFilter({
            freeText: freeTextInput,
            active: filter.active,
        });
        onFilterChange({
            freeText: freeTextInput,
            active: filter.active,
        });
    };

    const handleStatusSelected = (active: boolean | null) => {
        setFilter({
            freeText: filter.freeText,
            active: active,
        });
        onFilterChange({
            freeText: filter.freeText,
            active: active,
        });
    };
    return (
        <Box mb={1} display="flex" justifyContent="space-between" alignItems="center">
            <Grid container spacing={1}>
                <Grid item sm={3}>
                    <FreeTextFilterComponent
                        value={filter.freeText}
                        freeTextFilterChange={handleFilterChange}
                        label="search lab freetext"
                    />
                </Grid>
                <Grid item>
                    <FilterOnStatusDropdown statusSelected={handleStatusSelected} />
                </Grid>
            </Grid>
            <Button style={{ whiteSpace: 'nowrap' }} variant="contained" onClick={onAddLabDialogOpen}>
                {translate('organization:ADD_LAB')}
            </Button>
        </Box>
    );
};

export default LabPageActions;
